// extracted by mini-css-extract-plugin
export var root = "AMiM";